const status = [
  {
    id: 1,
    label: 'Todos',
    value: 'Todos'
  },
  {
    id: 2,
    label: 'Pedido realizado',
    value: 'Pedido realizado'
  },
  {
    id: 3,
    label: 'Em preparação',
    value: 'Em preparação'
  },
  {
    id: 4,
    label: 'Pedido pronto',
    value: 'Pedido pronto'
  },
  {
    id: 5,
    label: 'Pedido a caminho',
    value: 'Pedido a caminho'
  },
  {
    id: 6,
    label: 'Entregue',
    value: 'Entregue'
  }
]

export default status
